const tableRows = [
  {
    category: 'Цель',
    simple: '«Чтобы было красиво»',
    marketing: 'Продажи и новые клиенты',
  },
  {
    category: 'Контент',
    simple: 'Случайные посты',
    marketing: 'Контент по Лестнице Бена Ханта',
  },
  {
    category: 'Охват',
    simple: 'Только ваши подписчики',
    marketing: 'Весь рынок через рекламу и виральность',
  },
  {
    category: 'Результат',
    simple: 'Лайки и комментарии',
    marketing: 'Заявки в директ и звонки',
  },
];

export default function SMMDifference() {
  return (
    <section id="smm-difference" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-14">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            В чём разница: «Просто ведение соц. сетей»
            <span className="block mt-1"> и «Маркетинг и продвижение»</span>
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        {/* Two cards */}
        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
          <div className="bg-white rounded-2xl p-5 sm:p-8 border border-gray-100 hover:border-gray-300 transition-all duration-300">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gray-200 flex items-center justify-center flex-shrink-0">
                <i className="ri-user-3-line text-gray-500 text-lg"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-700 font-['Playfair_Display']">
                «Просто ведение»
              </h3>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed font-['Montserrat'] text-justify">
              Это когда администратор выкладывает котиков, доброе утро и фото товара. Это «живой» аккаунт,
              который видят только ваши старые подписчики. Это статичный процесс, который редко приводит
              новых клиентов.
            </p>
            <div className="mt-4 flex items-center gap-2 text-gray-400 text-xs font-['Montserrat']">
              <i className="ri-time-line"></i>
              <span>Статичный процесс — минимальный рост</span>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#253D6B] rounded-2xl p-5 sm:p-8 border border-[#1A2B4C]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-[#C5A880]/30 flex items-center justify-center flex-shrink-0">
                <i className="ri-rocket-2-line text-[#C5A880] text-lg"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-white font-['Playfair_Display']">
                «Маркетинг и продвижение»
              </h3>
            </div>
            <p className="text-sm text-white/80 leading-relaxed font-['Montserrat'] text-justify">
              Это активная охота. Мы не ждём, пока клиент нас найдёт, мы сами идём к нему. Это работа
              со смыслами, триггерами и платным трафиком, которая превращает соцсети в системный
              канал продаж.
            </p>
            <div className="mt-4 flex items-center gap-2 text-[#C5A880] text-xs font-['Montserrat']">
              <i className="ri-bar-chart-box-line"></i>
              <span>Активный рост — новые клиенты каждый месяц</span>
            </div>
          </div>
        </div>

        {/* Mobile comparison cards (shown only on xs, hidden on sm+) */}
        <div className="sm:hidden space-y-4">
          {/* Header */}
          <div className="grid grid-cols-2 gap-3 mb-1">
            <div className="bg-gray-200 rounded-xl px-4 py-3 text-center">
              <i className="ri-user-3-line text-gray-500 text-base block mb-1"></i>
              <span className="text-gray-600 text-xs font-bold font-['Montserrat'] uppercase tracking-wide">Просто ведение</span>
            </div>
            <div className="bg-[#1A2B4C] rounded-xl px-4 py-3 text-center">
              <i className="ri-rocket-2-line text-[#C5A880] text-base block mb-1"></i>
              <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] uppercase tracking-wide">Маркетинг</span>
            </div>
          </div>

          {tableRows.map((row, i) => (
            <div key={i} className="rounded-2xl overflow-hidden border border-gray-100">
              {/* Row label */}
              <div className="bg-[#1A2B4C] px-4 py-2">
                <span className="text-white text-xs font-bold font-['Montserrat'] uppercase tracking-widest">{row.category}</span>
              </div>
              {/* Two columns */}
              <div className="grid grid-cols-2">
                <div className="bg-white px-4 py-4 border-r border-gray-100 flex flex-col gap-1">
                  <p className="text-gray-500 text-xs font-['Montserrat'] leading-snug">{row.simple}</p>
                </div>
                <div className="bg-[#F9F5EF] px-4 py-4 flex flex-col gap-1">
                  <div className="flex items-start gap-1.5">
                    <i className="ri-check-line text-[#C5A880] text-sm flex-shrink-0 mt-0.5"></i>
                    <p className="text-[#1A2B4C] text-xs font-semibold font-['Montserrat'] leading-snug">{row.marketing}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop comparison table (hidden on mobile) */}
        <div className="hidden sm:block overflow-x-auto rounded-2xl border border-gray-100">
          <table className="w-full min-w-[540px]">
            <thead>
              <tr className="bg-[#1A2B4C]">
                <th className="text-left px-4 sm:px-6 py-4 text-white text-xs sm:text-sm font-semibold font-['Montserrat'] w-1/4">
                  Что делаем?
                </th>
                <th className="text-left px-4 sm:px-6 py-4 text-white/60 text-xs sm:text-sm font-semibold font-['Montserrat'] w-[37.5%]">
                  Просто ведение
                </th>
                <th className="text-left px-4 sm:px-6 py-4 text-[#C5A880] text-xs sm:text-sm font-semibold font-['Montserrat'] w-[37.5%]">
                  Маркетинг и продвижение
                </th>
              </tr>
            </thead>
            <tbody>
              {tableRows.map((row, i) => (
                <tr
                  key={i}
                  className={`border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-[#F9F5EF]'}`}
                >
                  <td className="px-4 sm:px-6 py-4 font-bold text-[#1A2B4C] text-xs sm:text-sm font-['Montserrat']">
                    {row.category}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-gray-500 text-xs sm:text-sm font-['Montserrat']">
                    {row.simple}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[#1A2B4C] font-semibold text-xs sm:text-sm font-['Montserrat']">
                    <span className="flex items-center gap-2">
                      <i className="ri-check-line text-[#C5A880]"></i>
                      {row.marketing}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
